export const tradesLocation = "/trading/trades";
